import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import './index.css';

console.log('[Main] GPU BOM Calculator starting...');
console.log('[Main] React version:', React.version);

try {
  const rootElement = document.getElementById('root');
  console.log('[Main] Root element found:', !!rootElement);

  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = ReactDOM.createRoot(rootElement);
  console.log('[Main] React root created successfully');

  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );

  console.log('[Main] App rendered successfully');
} catch (error) {
  console.error('[Main] Fatal error during initialization:', error);
  document.body.innerHTML = `
    <div style="padding: 20px; font-family: monospace; color: red;">
      <h1>Initialization Error</h1>
      <pre>${error}</pre>
      <p>Open the browser console (F12) for more details.</p>
    </div>
  `;
}
